// Replacement for vue-chat-scroll: scrolls the element to the bottom when its content changes
function scrollToBottom (el, options) {
  if (options.smooth) {
    el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' })
  } else {
    el.scrollTop = el.scrollHeight
  }
}

export default {
  install (app) {
    app.directive('chat-scroll', {
      mounted (el, binding) {
        const options = binding.value || {}
        let pinned = true
        el.addEventListener('scroll', () => {
          pinned = el.scrollTop + el.clientHeight + 1 >= el.scrollHeight
        })
        el.__chatScrollObserver = new MutationObserver(() => {
          if (options.always !== false || pinned) scrollToBottom(el, options)
        })
        el.__chatScrollObserver.observe(el, { childList: true, subtree: true })
        scrollToBottom(el, { smooth: false })
      },
      unmounted (el) {
        if (el.__chatScrollObserver) el.__chatScrollObserver.disconnect()
      }
    })
  }
}
